import React from 'react';
import Projections from '../SummaryPage/Comparison';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import PropertyPageHeader from '../../components/PropertyPageHeader';

export default function ProjectionsPage() {
  const { pathname } = useLocation();
  const sharing = pathname.includes('sharing');
  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Projections</title>
      </Helmet>
      <section className="pt-4">
        {!sharing && (
          <PropertyPageHeader
            title={'Projections'}
            description={
              'Projections for the property under different scenarios.'
            }
          />
        )}

        <Projections />
      </section>
    </>
  );
}
